import { render, staticRenderFns } from "./IconBlockTemplate.vue?vue&type=template&id=c67a8e06&scoped=true"
import script from "./IconBlockTemplate.vue?vue&type=script&lang=js"
export * from "./IconBlockTemplate.vue?vue&type=script&lang=js"
import style0 from "./IconBlockTemplate.vue?vue&type=style&index=0&id=c67a8e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67a8e06",
  null
  
)

export default component.exports